import SubjectAreaRepository, {FilterParams} from '../../../networking/repos/SubjectAreaRepository';
import {usePaginationQueryConfig, useQueryConfig} from '../Utils';
import {SubjectAreaQueryKey} from './Key';

export const useSubjectAreaIndexQueryConfig = () => {
    const repo = new SubjectAreaRepository();

    return useQueryConfig(SubjectAreaQueryKey.base, () => repo.all());
};

export const useSubjectAreaFilteredQueryConfig = (params: FilterParams) => {
    const repo = new SubjectAreaRepository();

    return usePaginationQueryConfig(
        (page) => SubjectAreaQueryKey.filtered({ ...params, page }),
        (page) => repo.allPaginated({ ...params, page })
    );
};

export const useSubjectAreaFilterOptionsQueryConfig = () => {
    const repo = new SubjectAreaRepository();

    return useQueryConfig(SubjectAreaQueryKey.filterOptions, () => repo.getFilters());
};


